"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACIL_DURUM_BELGE_TIP_ETIKETI = exports.KONTROLLU_BELGE_TIP_ETIKETI = exports.acilDurumBelgeTipiSchema = exports.kontrolluBelgeTipiSchema = exports.KONTROLLU_BELGE_TIPLERI = exports.DOKUMAN_RAF_TIPLERI = exports.ACIL_DURUM_BELGE_TIPLERI = void 0;
const zod_1 = require("zod");
/**
 * KONTROLLÜ BELGE — TİP KİMLİKLERİ (Kapsam §29/E1 · §31/K2; ERD §10i · §10k).
 *
 * ════════════════════════════════════════════════════════════════════════
 * RAF, ÇEKİRDEĞİN İKİNCİ MÜŞTERİSİDİR — VE İLK MÜŞTERİNİN VARSAYIMI
 * ÇEKİRDEĞİN KURALI DEĞİLDİR
 * ════════════════════════════════════════════════════════════════════════
 *
 * `controlled_document` tek tablodur; iki müşterisi vardır:
 *   · ACİL DURUM (06.09.2026) — iki TEKİL tip: işyerinde tek belge, her satır
 *     bir SÜRÜM, *güncel* türetilir, yenileme vadesi #17'den.
 *   · DOKÜMAN RAFI (07.09.2026) — altı RAF tipi: KATEGORİ (bir sekmede on
 *     prosedür yan yana); *güncel* TÜRETİLMEZ, yasal bağ ve vade YOK (K3),
 *     sürüm zinciri v2 (K6).
 *
 * ⚠️ Yapı (tekil / raf) ve sekme, tipin KURALIDIR ve `@isg/db
 * controlled-document-rules.ts`teki haritada yaşar; burada yalnız kimlik ve
 * etiket durur. İki liste buradan TÜRETİLİR — ikinci bir liste yazılmaz:
 * acil durum yükleme şeması `acilDurumBelgeTipiSchema`, raf yükleme şeması
 * `DOKUMAN_RAF_TIPLERI` okur. Yeni tip = buraya kimlik + haritaya satır;
 * tablo değişmez.
 */
exports.ACIL_DURUM_BELGE_TIPLERI = ['acil_durum_plani', 'tahliye_krokisi'];
/** Raf tipleri = raf sekmeleri (K1 — altı sekme; token Türkçe ASCII, enum'un kendi konvansiyonu). */
exports.DOKUMAN_RAF_TIPLERI = [
    'plan',
    'politika',
    'prosedur',
    'talimat',
    'form',
    'sema',
    // D2-3 (17.09.2026 — Kapsam §14): tanımlı tipler dışı belge; serbest ad zorunlu.
    'diger',
    // P2 — Namet grubu (01.11.2026 — Kapsam §14): Güvenlik Bilgi Formu; tip-özel iki
    // alan (`kimyasal_adi` zorunlu · `gbf_duzenleme_tarihi` opsiyonel), D2-3 emsali.
    'gbf',
];
exports.KONTROLLU_BELGE_TIPLERI = [
    ...exports.ACIL_DURUM_BELGE_TIPLERI,
    ...exports.DOKUMAN_RAF_TIPLERI,
];
exports.kontrolluBelgeTipiSchema = zod_1.z.enum(exports.KONTROLLU_BELGE_TIPLERI);
exports.acilDurumBelgeTipiSchema = zod_1.z.enum(exports.ACIL_DURUM_BELGE_TIPLERI);
exports.KONTROLLU_BELGE_TIP_ETIKETI = {
    acil_durum_plani: 'Acil durum planı',
    tahliye_krokisi: 'Tahliye vaziyet planı (kroki)',
    plan: 'Plan',
    politika: 'Politika',
    prosedur: 'Prosedür',
    talimat: 'Talimat',
    form: 'Form',
    sema: 'Şema',
    diger: 'Diğer',
    gbf: 'Güvenlik Bilgi Formu (GBF)',
};
/** Acil durum sayfasının (ve yükleme Select'inin) okuduğu alt küme — TÜRETİLİR. */
exports.ACIL_DURUM_BELGE_TIP_ETIKETI = Object.fromEntries(exports.ACIL_DURUM_BELGE_TIPLERI.map((tip) => [tip, exports.KONTROLLU_BELGE_TIP_ETIKETI[tip]]));
//# sourceMappingURL=kontrollu-belge.js.map